import React from 'react';

const UserList = ({ searchQuery, onSelectUser, selectedUser }) => {
  const users = [
    {
      id: '1',
      name: 'John Doe',
      status: 'Online',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=32&h=32&fit=crop&crop=faces',
      lastMessage: 'Hey, how are you?',
      lastMessageTime: '10:30 AM',
    },
    {
      id: '2',
      name: 'Jane Smith',
      status: 'In a meeting',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=32&h=32&fit=crop&crop=faces',
      lastMessage: 'Can we discuss the project?',
      lastMessageTime: 'Yesterday',
    },
  ];

  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="divide-y divide-gray-200">
      {filteredUsers.map((user) => (
        <button
          key={user.id}
          onClick={() => onSelectUser(user)}
          className={`w-full p-4 flex items-center space-x-3 hover:bg-gray-50 ${
            selectedUser?.id === user.id ? 'bg-blue-50' : ''
          }`}
        >
          <div className="relative">
            <img
              src={user.avatar}
              alt={user.name}
              className="w-12 h-12 rounded-full"
            />
            <span
              className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white ${
                user.status === 'Online' ? 'bg-green-500' : 'bg-gray-500'
              }`}
            />
          </div>
          <div className="flex-1 text-left">
            <h3 className="font-medium text-gray-900">{user.name}</h3>
            <p className="text-sm text-gray-500 truncate">{user.lastMessage}</p>
          </div>
          <span className="text-xs text-gray-500">{user.lastMessageTime}</span>
        </button>
      ))}
    </div>
  );
};

export default UserList;
